<template>
  <b-modal
    id="booking-modal"
    ref="modal"
    :hide-footer="true"
    size="lg"
    @hidden="closeModal"
    @show="resetModal"
  >
    <template v-slot:modal-title>
      {{ modalName }}
    </template>

    <b-form
      @submit.stop.prevent="onSubmit"
    >
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-time"
            label="Time"
            label-for="input-time"
          >
            <b-input
              id="input-time"
              v-model="$v.form.time.$model"
              type="time"
              :state="validateState('time')"
              aria-describedby="input-time-live-feedback"
            />
            <b-form-invalid-feedback id="input-time-live-feedback">
              Time is required (in HH:mm format)
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            id="input-group-date"
            label="Date"
            label-for="input-date"
          >
            <b-input
              id="input-date"
              v-model="$v.form.date.$model"
              :state="validateState('date')"
              hidden
              type="date"
              aria-describedby="input-date-live-feedback"
            />
            <date-picker
              v-model="$v.form.date.$model"
              :input-class="'form-control date-input '+ (validateState('date') === true?
                'is-valid':validateState('date') === false ? 'is-invalid': '')"
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              type="date"
              :lang="lang"
            />
            <b-form-invalid-feedback id="input-date-live-feedback">
              Date is required
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            id="input-group-alert"
            label="Alert"
            label-for="input-alert"
          >
            <b-input
              id="input-alert"
              v-model="$v.form.alert.$model"
              :state="validateState('alert')"
              type="number"
              placeholder="Minutes"
              aria-describedby="input-alert-live-feedback"
            />
            <b-form-invalid-feedback id="input-alert-live-feedback">
              Please enter alert in minutes
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col
          lg="8"
          md="7"
          cols="12"
        >
          <b-form-group
            id="input-group-pname"
            label="Passenger Name"
            label-for="input-pname"
          >
            <b-input
              id="input-pname"
              v-model="$v.form.passenger.$model"
              :state="validateState('passenger')"
              type="text"
              placeholder="Enter name"
              aria-describedby="input-passenger-live-feedback"
            />
            <b-form-invalid-feedback id="input-passenger-live-feedback">
              Passenger name is required
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          lg="4"
          md="5"
          cols="6"
        >
          <b-form-group
            id="input-group-pnumber"
            label="Total # of Passengers"
            label-for="input-pnumber"
          >
            <b-input
              id="input-pnumber"
              v-model="$v.form.passengerNumber.$model"
              type="number"
              :state="validateState('passengerNumber')"
              placeholder="Enter number"
              aria-describedby="input-pnumber-live-feedback"
            />
            <b-form-invalid-feedback id="input-pnumber-live-feedback">
              Please enter 0 or more
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          lg="8"
          md="7"
          cols="12"
        >
          <b-form-group
            id="input-group-phone"
            label="Phone Number"
            label-for="input-phone"
          >
            <b-input
              id="input-phone"
              v-model="$v.form.passengerPhone.$model"
              placeholder="Enter phone"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col
          lg="4"
          md="5"
          cols="6"
        >
          <b-form-group
            id="input-group-totalcars"
            label="Total # of Cars"
            label-for="input-totalcars"
          >
            <b-form-input
              id="input-totalcars"
              v-model="$v.form.carNumber.$model"
              type="number"
              :state="validateState('carNumber')"
              aria-describedby="input-tcars-live-feedback"
              placeholder="Enter number"
              :disabled="editMode"
            />
            <b-form-invalid-feedback id="input-tcars-live-feedback">
              Please enter a number above 0
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-2 d-none d-sm-flex" v-if="form.carTypes.length>0">
        <b-col
          lg="5"
          sm="7"
        >
          Car Type
        </b-col>
        <b-col
          lg="3"
          sm="5"
        >
          # of Passengers
        </b-col>
      </b-row>
      <b-row
        v-for="(carType, index) in form.carTypes"
        :key="carType.id"
      >
        <b-col
          lg="5"
          sm="7"
        >
          <div class="mb-2 d-sm-none">
            Car Type
          </div>
          <multiselect
            v-model="carType.selectedCarType"
            placeholder="Car Type"
            :options="carTypes"
            :searchable="false"
            :allow-empty="false"
            select-label="✓"
            deselect-label="✗"
            selected-label=""
            class="select-with-symbol"
          >
            <template
              slot="option"
              slot-scope="props"
            >
              <div class="d-flex">
                <div
                  class="car-type"
                  :style="{'background':props.option.colourCode}"
                />
                <span>{{ props.option.type }}</span>
              </div>
            </template>
            <template
              slot="singleLabel"
              slot-scope="{ option }"
            >
              <div class="d-flex">
                <div
                  class="car-type van"
                  :style="{'background':option.colourCode}"
                />
                <span>{{ option.type }}</span>
              </div>
            </template>
          </multiselect>
        </b-col>
        <b-col
          lg="3"
          sm="5"
        >
          <div class="mb-2 d-sm-none mt-2">
            # of Passengers
          </div>
          <b-form-group
            id="input-group-carnumber1"
            class="mb-3 mb-sm-2"
          >
            <b-input
              id="input-8carnumber1"
              v-model="$v.form.carTypes.$each[index].amount.$model"
              type="number"
              :state="validateCarTypesAmountState(index)"
              :aria-describedby="`input-cnumber-live-feedback-${index}`"
              placeholder="Enter number"
              @change="changeNumberOfPassengers"
            />
            <b-form-invalid-feedback :id="`input-cnumber-live-feedback-${index}`">
              Please enter a number of passengers
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col
          lg="5"
          cols="7"
        >
          <b-form-group
            id="input-group-airport"
            label="Airport"
            label-for="input-airport"
          >
            <b-input
              id="input-airport"
              v-model="$v.form.airport.$model"
              :state="validateState('airport')"
            />
          </b-form-group>
        </b-col>

        <b-col
          lg="2"
          cols="5"
        >
          <b-form-group
            id="input-group-flight"
            label="Flight #"
            label-for="input-flight"
          >
            <b-form-input
              id="input-flight"
              v-model="$v.form.flightNumber.$model"
              :state="validateState('flightNumber')"
            />
          </b-form-group>
        </b-col>

        <b-col
          lg="5"
          cols="7"
        >
          <b-form-group
            id="input-group-origin"
            label="Origin Airport"
            label-for="input-origin"
          >
            <b-form-input
              id="input-origin"
              v-model="$v.form.origin.$model"
              :state="validateState('origin')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col
          lg="5"
          sm="6"
          cols="12"
        >
          <div class="mb-2">
            From Address
          </div>
          <address-input
            id="input-from1"
            v-model="$v.form.addressFrom.address1.$model"
            :state="validateState('addressFrom.address1')"
            input-class="mb-2"
            placeholder="Address 1"
            @hit="onAddressHit($event,$v.form.addressFrom)"
          />
          <b-input
            id="input-from2"
            v-model="$v.form.addressFrom.address2.$model"
            class="mb-2"
            placeholder="Address 2"
            :state="validateState('addressFrom.address2')"
          />
          <b-input
            id="input-fromTown"
            v-model="$v.form.addressFrom.town.$model"
            class="mb-2"
            placeholder="Town"
            :state="validateState('addressFrom.town')"
            aria-describedby="input-fromTown-live-feedback"
          />
          <b-form-invalid-feedback id="input-fromTown-live-feedback">
            Town is required
          </b-form-invalid-feedback>
          <b-input
            id="input-fromPc"
            v-model="$v.form.addressFrom.postCode.$model"
            class="mb-2"
            placeholder="Post Code"
            :state="validateState('addressFrom.postCode')"
            aria-describedby="input-postCode-live-feedback"
          />
          <b-form-invalid-feedback id="input-postCode-live-feedback">
            Postcode is required
          </b-form-invalid-feedback>
        </b-col>

        <b-col
          lg="5"
          sm="6"
          cols="12"
          class="mt-sm-0 mt-2"
        >
          <div class="mb-2">
            To Address
          </div>
          <address-input
            id="input-to1"
            v-model="$v.form.addressTo.address1.$model"
            :state="validateState('addressTo.address1')"
            input-class="mb-2"
            placeholder="Address 1"
            @hit="onAddressHit($event,$v.form.addressTo)"
          />
          <b-input
            id="input-to2"
            v-model="$v.form.addressTo.address2.$model"
            class="mb-2"
            placeholder="Address 2"
            :state="validateState('addressTo.address2')"
          />
          <b-input
            id="input-toTown"
            v-model="$v.form.addressTo.town.$model"
            class="mb-2"
            placeholder="Town"
            :state="validateState('addressTo.town')"
            aria-describedby="input-toTown-live-feedback"
          />
          <b-form-invalid-feedback id="input-toTown-live-feedback">
            Town is required
          </b-form-invalid-feedback>
          <b-input
            id="input-toPc"
            v-model="$v.form.addressTo.postCode.$model"
            class="mb-2"
            placeholder="Post Code"
            :state="validateState('addressTo.postCode')"
            aria-describedby="input-topostCode-live-feedback"
          />
          <b-form-invalid-feedback id="input-topostCode-live-feedback">
            Postcode is required
          </b-form-invalid-feedback>
        </b-col>

        <b-col
          lg="2"
          cols="6"
          class="pt-lg-2"
        >
          <br>
          <b-button
            variant="primary"
            class="w-100 mb-2"
            @click="form.via1Show = !form.via1Show"
          >
            <span v-if="form.via1Show">-</span>
            <span v-else>+</span>
            Via 1
          </b-button>
          <b-button
            variant="primary"
            class="w-100"
            @click="form.via2Show = !form.via2Show"
          >
            <span v-if="form.via2Show">-</span>
            <span v-else>+</span>
            Via 2
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col
          v-if="form.via1Show"
          lg="5"
          cols="12"
        >
          <div class="mb-2">
            Via 1
          </div>
          <address-input
            id="input-via11"
            v-model="$v.form.viaAddress1.address1.$model"
            :state="validateState('viaAddress1.address1')"
            input-class="mb-2"
            placeholder="Address 1"
            @hit="onAddressHit($event,$v.form.viaAddress1)"
          />
          <b-input
            id="input-via12"
            v-model="$v.form.viaAddress1.address2.$model"
            class="mb-2"
            placeholder="Address 2"
            :state="validateState('viaAddress1.address2')"
          />
          <b-input
            id="input-via1Town"
            v-model="$v.form.viaAddress1.town.$model"
            class="mb-2"
            placeholder="Town"
            :state="validateState('viaAddress1.town')"
            aria-describedby="input-via1Town-live-feedback"
          />
          <b-form-invalid-feedback id="input-via1Town-live-feedback">
            Town is required
          </b-form-invalid-feedback>
          <b-input
            id="input-via1Pc"
            v-model="$v.form.viaAddress1.postCode.$model"
            class="mb-2"
            placeholder="Post Code"
            :state="validateState('viaAddress1.postCode')"
            aria-describedby="input-via1postCode-live-feedback"
          />
          <b-form-invalid-feedback id="input-via1postCode-live-feedback">
            Postcode is required
          </b-form-invalid-feedback>
        </b-col>

        <b-col
          v-if="form.via2Show"
          lg="5"
          cols="12"
          class="mt-2 mt-lg-0"
        >
          <div class="mb-2">
            Via 2
          </div>
          <address-input
            id="input-via21"
            v-model="$v.form.viaAddress2.address1.$model"
            :state="validateState('viaAddress2.address1')"
            input-class="mb-2"
            placeholder="Address 1"
            @hit="onAddressHit($event,$v.form.viaAddress2)"
          />
          <b-input
            id="input-via22"
            v-model="$v.form.viaAddress2.address2.$model"
            class="mb-2"
            placeholder="Address 2"
            :state="validateState('viaAddress2.address2')"
          />
          <b-input
            id="input-via2Town"
            v-model="$v.form.viaAddress2.town.$model"
            class="mb-2"
            placeholder="Town"
            :state="validateState('viaAddress2.town')"
            aria-describedby="input-via2Town-live-feedback"
          />
          <b-form-invalid-feedback id="input-via2Town-live-feedback">
            Town is required
          </b-form-invalid-feedback>
          <b-input
            id="input-via2Pc"
            v-model="$v.form.viaAddress2.postCode.$model"
            class="mb-2"
            placeholder="Post Code"
            :state="validateState('viaAddress2.postCode')"
            aria-describedby="input-via2postCode-live-feedback"
          />
          <b-form-invalid-feedback id="input-via2postCode-live-feedback">
            Postcode is required
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col
          lg="5"
          sm="6"
          cols="12"
        >
          <b-form-group
            id="input-group-note"
            class="mb-2 mb-lg-3"
            label="Note"
            label-for="input-note"
          >
            <b-form-input
              id="input-note"
              v-model="$v.form.note.$model"
              :state="validateState('note')"
            />
          </b-form-group>
        </b-col>

        <b-col
          lg="5"
          sm="6"
          cols="12"
        >
          <b-form-group
            id="input-group-status"
            class="mb-2 mb-lg-3"
            label="Status"
            label-for="input-status"
          >
            <b-form-input
              id="input-status"
              :value="verboseStatus(form.status)"
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col
          lg="2"
          cols="6"
          class="pt-lg-4 pt-sm-0 mb-3"
          offset-md="6"
          offset-lg="0"
        >
          <b-button
            variant="info"
            class="w-100 mt-lg-2 mt-md-0 mt-2"
            :disabled="form.status && form.status === constants.bookingStatus.Booked"
            @click="stepBack()"
          >
            <i class="fa fa-backward"/>
          </b-button>
        </b-col>
        <b-col
                lg="5"
                sm="6"
                cols="12"
                class="d-flex align-items-center">
          <b-form-group
                  id="input-group-6"
                  class="mb-1"
          >
            <b-form-checkbox
                    v-model="$v.form.notificationFallbackDisabled.$model"
                    size="md"
                    class="flex-shrink-0"
            >
              Don't send details over SMS
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          class="mr-2"
          variant="warning"
          :disabled="form.status !== constants.bookingStatus.Accepted && form.status !== constants.bookingStatus.Allocated"
          @click="clear()"
        >
          Clear
        </b-button>
        <b-button
          type="submit"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import {required, between, requiredIf} from "vuelidate/lib/validators";
  import {mapGetters} from "vuex";
  import Multiselect from 'vue-multiselect'
  import moment from "moment"
  import validateStateMixin from "../mixins/validateStateMixin";
  import AddressInput from "./AddressInput";
  import Constants from "../utils/Constants";
  import DatePicker from "vue2-datepicker"
  import 'vue2-datepicker/locale/en';
  const timeValidation = (value) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)

  export default {
    name: "BookingModal",
    components: {AddressInput, Multiselect, DatePicker},
    mixins: [validateStateMixin, AddressInput],
    props: ['open', 'value', 'clearBookingCallback','valueCopyFrom'],
    data() {
      return {
        constants: Constants,
        form: {
          time: '',
          date: "",
          alert: 0,
          passenger: "",
          passengerNumber: "",
          passengerPhone: "",
          carNumber: 1,
          carTypes: [],
          airport: "",
          flightNumber: "",
          origin: "",
          addressFrom: {
            address1: "",
            address2: "",
            town: "",
            postCode: ""
          },
          addressTo: {
            address1: "",
            address2: "",
            town: "",
            postCode: ""
          },
          viaAddress1: {
            address1: "",
            address2: "",
            town: "",
            postCode: ""
          },
          viaAddress2: {
            address1: "",
            address2: "",
            town: "",
            postCode: ""
          },
          note: "",
          status: "",
          via1Show: false,
          via2Show: false,
          notificationFallbackDisabled: false,
        },
        modalName: "New Booking",
        show: true,
        carTypes: [],
        editMode: false,
        lang: {
          formatLocale: {
            firstDayOfWeek: 1,
          },
          monthBeforeYear: false,
        },
        hasUserEditedPassengerNumber: false
      };
    },
    validations: function () {
      let vm = this;
      return {
        form: {
          time: {
            required,
            timeValidation
          },
          date: {
            required
          },
          alert: {
            between: between(0, 999),
            required
          },
          passenger: {
            required
          },
          passengerPhone: {},
          passengerNumber: {
            between: between(0, 999),
            required
          },
          carNumber: {
            between: between(1, 20),
            required
          },
          airport: {},
          flightNumber: {},
          origin: {},
          note: {},
          addressFrom: {
            address1: {required},
            address2: {},
            town: {required},
            postCode: {required}
          },
          addressTo: {
            address1: {required},
            address2: {},
            town: {required},
            postCode: {required}
          },
          viaAddress1: {
            address1: {
              requiredIf: requiredIf(function () {
                return vm.form.via1Show;
              })
            },
            address2: {},
            town: {
              requiredIf: requiredIf(function () {
                return vm.form.via1Show;
              })
            },
            postCode: {
              requiredIf: requiredIf(function () {
                return vm.form.via1Show;
              })
            }
          },
          viaAddress2: {
            address1: {
              requiredIf: requiredIf(function () {
                return vm.form.via2Show;
              })
            },
            address2: {},
            town: {
              requiredIf: requiredIf(function () {
                return vm.form.via2Show;
              })
            },
            postCode: {
              requiredIf: requiredIf(function () {
                return vm.form.via2Show;
              })
            }
          },
          carTypes: {
            $each: {
              amount: {
                required,
                between: between(0, 100),
              }
            }
          },
          notificationFallbackDisabled: {}
        }
      }
    },
    watch: {
      carNumber(newValue, oldValue) {
        if (!newValue || newValue > 20) {
          return;
        }
        newValue = parseInt(newValue);
        oldValue = parseInt(this.form.carTypes.length);
        if (newValue < 1) {
          return;
        }
        let difference = newValue - oldValue;
        if (difference > 0) {
          while (difference-- > 0) {
            this.form.carTypes.push({
              selectedCarType: this.carTypes[0],
              amount: undefined
            });
          }
          return;
        }
        while (difference++ < 0) {
          this.form.carTypes.pop()
        }
      },
      passengerNumber: function (newValue) {
        newValue = parseInt(newValue);
        if (newValue < 0 || this.hasUserEditedPassengerNumber || this.editMode) return;
        if (this.form.carTypes[0]) {
          this.form.carTypes[0].amount = newValue;
        }
      },
      open: function () {
        if (this.open) {
          this.$refs['modal'].show()
        } else {
          this.$refs['modal'].hide()
        }
      },
    },
    methods: {
      validateCarTypesAmountState(index) {
        const {$dirty, $error} = this.$v.form.carTypes.$each[index].amount;
        return $dirty ? !$error : null;
      },
      changeNumberOfPassengers(){
        this.hasUserEditedPassengerNumber = true;
      },
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        let form = {
          bookings: []
        };
        form.bookings = this.form.carTypes.map(carType => {
          return {
            date: moment(`${this.form.date} ${this.form.time}`).toISOString(),
            timeAlertInMinutes: parseInt(this.form.alert),
            passengerName: this.form.passenger,
            numberOfpassengers: parseInt(this.form.passengerNumber),
            phoneNumber: this.form.passengerPhone,
            eventId: this.selectedHeaderEvent,
            flightNumber: this.form.flightNumber,
            airport: this.form.airport,
            flyingFrom: this.form.origin,
            addressFrom: this.form.addressFrom,
            addressTo: this.form.addressTo,
            viaAddress1: this.form.via1Show ? this.form.viaAddress1 : {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            viaAddress2: this.form.via2Show ? this.form.viaAddress2 : {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            driverNote: this.form.note,
            passengersCount: parseInt(carType.amount),
            carTypeId: carType.selectedCarType.id,
            carId: this.form.carId,
            notificationFallbackDisabled: this.form.notificationFallbackDisabled
          }
        });
        try {
          for (const booking of form.bookings) {
            if (this.editMode) {
              await this.$http.put(`bookings/${this.value.id}`, booking);
            } else {
              await this.$http.post('bookings', booking);
            }
          }
        } catch (error) {
          this.handleErrorResponse(error);
        }
        this.closeModal();

      },
      closeModal() {
        this.$emit('modal-closed')
      },
      resetModal() {
        this.$v.form.$reset();
        this.hasUserEditedPassengerNumber = false;
        if (this.value) {
          this.editMode = true;
          this.form = {
            time: moment.utc(this.value.date).local().format('HH:mm'),
            date: moment.utc(this.value.date).local().format('YYYY-MM-DD'),
            alert: this.value.timeAlertInMinutes,
            passenger: this.value.passengerName,
            passengerNumber: this.value.numberOfPassengers,
            passengerPhone: this.value.phoneNumber,
            carNumber: 1,
            carTypes: [{
              amount: this.value.passengersCount,
              selectedCarType: this.value.carType
            }],
            airport: this.value.airport,
            flightNumber: this.value.flightNumber,
            origin: this.value.flyingFrom,
            addressFrom: this.value.addressFrom,
            addressTo: this.value.addressTo,
            viaAddress1: this.value.viaAddress1,
            viaAddress2: this.value.viaAddress2,
            note: this.value.driverNote,
            status: this.value.status,
            carId: this.value.carId,
            via1Show: (this.value.viaAddress1.address1 !== '' || this.value.viaAddress1.address2 !== '' ||
              this.value.viaAddress1.town !== '' || this.value.viaAddress1.postCode !== ''),
            via2Show: (this.value.viaAddress2.address1 !== '' || this.value.viaAddress2.address2 !== '' ||
              this.value.viaAddress2.town !== '' || this.value.viaAddress2.postCode !== ''),
            notificationFallbackDisabled: this.value.notificationFallbackDisabled
          };
        } else if (this.valueCopyFrom){
          this.editMode = false;
          this.form = {
            time: moment.utc(this.valueCopyFrom.date).local().format('HH:mm'),
            date: moment.utc(this.valueCopyFrom.date).local().format('YYYY-MM-DD'),
            alert: this.valueCopyFrom.timeAlertInMinutes,
            passenger: this.valueCopyFrom.passengerName,
            passengerNumber: this.valueCopyFrom.numberOfPassengers,
            passengerPhone: this.valueCopyFrom.phoneNumber,
            carNumber: 1,
            carTypes: [{
              amount: this.valueCopyFrom.passengersCount,
              selectedCarType: this.valueCopyFrom.carType
            }],
            airport: this.valueCopyFrom.airport,
            flightNumber: this.valueCopyFrom.flightNumber,
            origin: this.valueCopyFrom.flyingFrom,
            addressFrom: this.valueCopyFrom.addressFrom,
            addressTo: this.valueCopyFrom.addressTo,
            viaAddress1: this.valueCopyFrom.viaAddress1,
            viaAddress2: this.valueCopyFrom.viaAddress2,
            note: this.valueCopyFrom.driverNote,
            status: '',
            carId: this.valueCopyFrom.carId,
            via1Show: (this.valueCopyFrom.viaAddress1.address1 !== '' || this.valueCopyFrom.viaAddress1.address2 !== '' ||
                this.valueCopyFrom.viaAddress1.town !== '' || this.valueCopyFrom.viaAddress1.postCode !== ''),
            via2Show: (this.valueCopyFrom.viaAddress2.address1 !== '' || this.valueCopyFrom.viaAddress2.address2 !== '' ||
                this.valueCopyFrom.viaAddress2.town !== '' || this.valueCopyFrom.viaAddress2.postCode !== ''),
            notificationFallbackDisabled: this.valueCopyFrom.notificationFallbackDisabled
          };
        }
        else {
          this.editMode = false;
          this.form = {
            time: moment().set({second: 0, millisecond: 0}).format('HH:mm'),
            date: moment().set({hour: 0, minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD'),
            alert: 30,
            passenger: "",
            passengerNumber: "",
            passengerPhone: "",
            carNumber: 1,
            carTypes: [
              {
                selectedCarType: this.carTypes[0],
                amount: undefined
              }
            ],
            airport: "",
            flightNumber: "",
            origin: "",
            addressFrom: {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            addressTo: {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            viaAddress1: {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            viaAddress2: {
              address1: "",
              address2: "",
              town: "",
              postCode: ""
            },
            note: "",
            status: "",
            via1Show: false,
            via2Show: false,
            notificationFallbackDisabled: false,
          };
        }
      },
      onAddressHit(addressOption, form) {
        form.address1.$model = addressOption.address1
        form.address2.$model = addressOption.address2
        form.town.$model = addressOption.town
        form.postCode.$model = addressOption.postCode
        form.$touch();
      },
      verboseStatus(status) {
        switch (status) {
          case this.constants.bookingStatus.Booked:
            return 'Booked';
          case this.constants.bookingStatus.Allocated:
            return 'Allocated';
          case this.constants.bookingStatus.Accepted:
            return 'Accepted';
          case this.constants.bookingStatus.Cleared:
            return 'Cleared';
          default:
            return '';
        }
      },
      async clear() {
        if (this.value) {
          await this.clearBookingCallback(this.value);
          this.closeModal();
        }
      },
      async stepBack() {
        if (this.value) {
          try {
            await this.$http.post(`bookings/${this.value.id}/back`);
          } catch (error) {
            this.handleErrorResponse(error);
          }
          this.closeModal();
        }
      }
    },
    computed: {
      carNumber() {
        return this.form.carNumber;
      },
      passengerNumber() {
        return this.form.passengerNumber;
      },
      ...mapGetters(['selectedHeaderEvent'])
    },
    async created() {
      try {
        let response = await this.$http.get('/cartypes');
        this.carTypes = response.data;
      } catch (error) {
        this.handleErrorResponse(error);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .car-type {
    margin-right: 8px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50px;
    border: solid 1px rgba(0, 0, 0, 0.125);
  }

  .cars-dropdown /deep/ .dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;

    .car-msg-status {
      margin-top: 0px;
      margin-right: 6px;
    }
  }

  .cars-dropdown /deep/ .dropdown-menu {
    width: 100%;
  }
</style>
